import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
    if (error.response?.status === 500 || (typeof error.response?.data === 'string' && error.response.data.includes("Internal Server Error"))) {
        throw new Error("Si è verificato un problema, riprova più tardi.");
    }
    const backendError = error.response?.data;
    const message = typeof backendError === 'string' 
        ? backendError 
        : (backendError?.message || backendError?.error || defaultMsg);
    throw new Error(message);
};

export const syncStripeCustomers = async () => {
    try {
        const response = await axios.post(api.syncStripeCustomers, {}, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante la sincronizzazione con Stripe");
    }
};

export const getCustomerBalance = async (vendorId) => {
    try {
        const response = await axios.get(api.getCustomerBalance(vendorId), {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante il recupero del credito del vendor");
    }
};

export const addVendorCredit = async (vendorId, amount) => {
    try {
        const response = await axios.post(`${api.addVendorCredit(vendorId)}?amount=${amount}`, {}, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'aggiunta del credito");
    }
};

export const getVendorTransactions = async (vendorId) => {
    try {
        const response = await axios.get(api.getVendorTransactions(vendorId), {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante il recupero delle transazioni");
    }
};
 